import { Controller } from "@hotwired/stimulus"
import _ from "lodash"

export default class FormController extends Controller<HTMLFormElement> {
  static values = {
    delay: {
      type: Number,
      default: 300,
    },
  }

  static targets = ["cancel"]

  declare readonly cancelTarget: HTMLButtonElement
  declare readonly delayValue?: number
  declare debouncedSubmit: _.DebouncedFunc<() => void>

  connect() {
    this.debouncedSubmit = _.debounce(() => this.submit(), this.delayValue)
  }

  disconnect() {
    this.debouncedSubmit.cancel()
  }

  submit() {
    this.element.requestSubmit()
  }

  reset() {
    this.element.reset()
  }

  cancel() {
    this.cancelTarget?.click()
  }
}
